export const defaultDateFormat = 'MM/DD/YYYY';
